import { DirectorSearchFilter } from '../../models/directorSearchFilter';

export interface IPortalDirectorsListState {
  searchFilter: DirectorSearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

export const initialPortalDirectorsListState: IPortalDirectorsListState = {
  searchFilter: {},
  currentPage: 1,
  pageSize: 10,
  sortBy: 'fullName',
  ascending: true
};
